import React from 'react';
import PropTypes from 'prop-types';
import { Route, Routes, Navigate } from 'react-router-dom';
import NotFound from '../components/NotFound';
import Layout from '../components/Layout';
import { getInitLanguage } from '../../helpers/pathname';

const supportedLanguage = getInitLanguage();

function AppRoutes({ t }) {
	return (
		<Routes>
			<Route
				path={'/'}
				element={<Navigate to={`/${supportedLanguage}`} />}
			/>
			<Route path={`/:language`} element={<Layout t={t} />} />
			<Route path="/*" element={<NotFound />} />
		</Routes>
	);
}

AppRoutes.propTypes = {
	t: PropTypes.func.isRequired,
};

export default AppRoutes;
